import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0b3744a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "merchants" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_4 = { class: "grid grid-cols-2 gap-3 items-center" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_6 = { class: "flex items-center justify-end" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_9 = { class: "mt-6" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_merchants_actions = _resolveComponent("merchants-actions")!
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.actions_state.is_actions_opened)
      ? (_openBlock(), _createBlock(_component_merchants_actions, {
          key: 0,
          "is-create": _ctx.actions_state.is_create,
          "is-update": _ctx.actions_state.is_update,
          "is-delete": _ctx.actions_state.is_delete,
          loading: _ctx.actions_state.is_actions_loading,
          "initial-value": _ctx.actions_state.initial_value,
          onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.actions_state.is_actions_opened = false)),
          onCreate: _ctx.onMerchantCreate,
          onUpdate: _ctx.onMerchantUpdate,
          onDelete: _ctx.onMerchantDelete
        }, null, 8, ["is-create", "is-update", "is-delete", "loading", "initial-value", "onCreate", "onUpdate", "onDelete"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Мерчанты" }),
      _createVNode(_component_the_button, {
        class: "primary small",
        onClick: _ctx.startCreate
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Добавить мерчанта ")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("form", {
      class: "bg-white border px-4 py-2 mt-6",
      onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.loadMerchants(1)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Компания",
          loading: _ctx.data_state.companies.is_loading,
          failed: _ctx.data_state.companies.is_failed,
          "error-text": "При получении списка компаний произошла ошибка",
          options: _ctx.data_state.companies.list,
          value: _ctx.filters.companyId,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.companyId) = $event)),
          "infinite-scroll": "",
          "search-without-refresh": "",
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
          onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
          class: "mt-2"
        }, null, 8, ["loading", "failed", "options", "value"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Статус",
          options: _ctx.ACTIVE_OPTIONS,
          value: _ctx.filters.isActive,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.isActive) = $event)),
          "select-by": "value",
          class: "mt-2"
        }, null, 8, ["options", "value"]),
        _hoisted_5,
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_component_the_button, {
            class: "second text small mt-2",
            loading: _ctx.state.is_loading,
            disabled: _ctx.data_state.companies.is_loading || _ctx.state.is_loading,
            onClick: _ctx.resetFilters
          }, {
            default: _withCtx(() => [
              _hoisted_7,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"]),
          _createVNode(_component_the_button, {
            class: "primary text small mt-2",
            loading: _ctx.state.is_loading,
            disabled: _ctx.state.is_loading,
            type: "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_8,
              _createTextVNode(" Поиск ")
            ]),
            _: 1
          }, 8, ["loading", "disabled"])
        ])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.state.is_failed && !_ctx.state.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.is_loading,
            text: "При получении списка мерчантов произошла ошибка",
            "error-message": _ctx.state.failure.error_state.message,
            "error-url": _ctx.state.failure.error_state.url,
            "error-status": _ctx.state.failure.error_state.status,
            onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadMerchants(_ctx.state.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.is_loading,
                columns: _ctx.MerchantsColumns,
                rows: _ctx.state.list,
                pagination: "",
                "pagination-current-page": _ctx.state.pagination.current_page,
                "pagination-limit": _ctx.state.pagination.limit,
                "pagination-total-items": _ctx.state.pagination.total_items,
                "pagination-total-pages": _ctx.state.pagination.total_pages,
                onChangePage: _ctx.loadMerchants
              }, {
                actions: _withCtx(({ row }) => [
                  _createVNode(_component_the_button, {
                    hint: "Редактировать",
                    class: "primary extra-small mr-3",
                    loading: _ctx.state.is_loading,
                    onClick: ($event: any) => (_ctx.startUpdate(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["loading", "onClick"]),
                  _createVNode(_component_the_button, {
                    hint: "Удалить",
                    class: "red extra-small",
                    loading: _ctx.state.is_loading,
                    onClick: ($event: any) => (_ctx.startDelete(row))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 2
                  }, 1032, ["loading", "onClick"])
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-current-page", "pagination-limit", "pagination-total-items", "pagination-total-pages", "onChangePage"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}